import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatDistanceToNow } from 'date-fns';
import { Loader2 } from 'lucide-react';

const RecentActivity = ({ tasks, isLoading }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <Card className="bg-slate-800/70 border-slate-700 shadow-xl">
        <CardHeader>
          <CardTitle className="text-xl text-slate-200">Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="space-y-3">
              {[...Array(3)].map((_, i) => (
                <li key={i} className="flex items-center p-3 bg-slate-700/50 rounded-md animate-pulse">
                  <div className="w-8 h-8 bg-slate-600 rounded-full mr-3"></div>
                  <div className="flex-1 space-y-2">
                    <div className="h-4 bg-slate-600 rounded w-3/4"></div>
                    <div className="h-3 bg-slate-600 rounded w-1/2"></div>
                  </div>
                </li>
              ))}
            </div>
          ) : tasks.length > 0 ? (
            <ul className="space-y-3">
              {tasks.map((task) => (
                <li key={task.id} className="flex items-center p-3 bg-slate-700/50 rounded-md hover:bg-slate-700 transition-colors">
                  <div className={`w-3 h-3 rounded-full mr-3 ${task.projects ? 'bg-blue-500' : 'bg-gray-500'}`}></div>
                  <div>
                    <p className="text-sm font-medium text-slate-100">{task.name}</p>
                    <p className="text-xs text-slate-400">
                      {task.projects ? `Project: ${task.projects.name} - ` : ''}
                      Updated {formatDistanceToNow(new Date(task.updated_at), { addSuffix: true })}
                      {task.employees ? ` by ${task.employees.name}` : ''}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-slate-400 text-center py-4">No recent activity.</p>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default RecentActivity;